// Local
// export const ADMIN_ENDPOINT = "http://localhost:8098/admin";

// Staging
// export const ADMIN_ENDPOINT = "https://esiproapi.staging.nowbst.com/admin";

// QA
// export const ADMIN_ENDPOINT = "https://esiproapi.staging.nowbst.com/admin";

// Prod
// export const ADMIN_ENDPOINT = "https://esiproapi.staging.nowbst.com/admin";

// China
// export const ADMIN_ENDPOINT = "https://esiapi.esipro.cn/admin";

export const ADMIN_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "https://esiproapi.staging.nowbst.com/admin";

export default {
  ADMIN_ENDPOINT,
};
